<template>
  <TheUncle :color="true" title="사입 로그" description="사입 로그입니다.">
    <div style="margin-bottom: 20px;">
      <a-alert
        style="margin-bottom: 0.5em;"
        type="warning"
        message="최근 7일 동안의 내역입니다."
        description="이전의 기록을 확인하려면 날짜를 선택해주세요."
        closable
        showIcon
      />

      <div style="margin-bottom: 20px;">
        <a-row :gutter="8">
          <a-col :span="24" :md="12">
            <a-range-picker
              @change="onDateUpdate"
              style="width: 96%"
              :ranges="{ '오늘': [$moment(), $moment()], '이번 달': [$moment().startOf('month'), $moment().endOf('month')] }"
              format="LL"
            />
          </a-col>
          <a-col :span="24" :md="12">
            <a-auto-complete
              placeholder="사용자 검색"
              v-model="search"
              @search="onSearch"
              :dataSource="autoComplete"
              v-on:keypress.native="onSearchChange"
              style="width: 100%"
            >
              <a-input>
                <a-icon slot="suffix" type="search" @click="onSearch" />
              </a-input>
            </a-auto-complete>
          </a-col>
          <a-col :span="24" :md="20">
            <a-select
              mode="multiple"
              style="width: 96%; margin-left: 10px"
              v-model="selected.filter"
              placeholder="필터"
            >
              <a-select-option v-for="(filterName, index) of filter" :key="index">{{ filterName }}</a-select-option>
            </a-select>
          </a-col>
          <a-col :span="24" :md="4">
            <a-button type="primary" icon="search" style="width: 100%" @click="refreshLogs()">검색</a-button>
          </a-col>
        </a-row>
      </div>
    </div>
    <a-card>
      <a-collapse accordion>
        <a-collapse-panel
          v-for="i in Object.keys(logs)"
          :key="i"
          :class="`admin-color-${logs[i][0].status}`"
          :header="
        `[${
          logs[i][0].type === 0 ? '사입' : '교환 / 반납'
        }][${logs[i][0].status === 0 ? '접수' 
          : logs[i][0].status === 1 ? '처리 중' 
          : logs[i][0].status === 2 ? '성공' 
          : logs[i][0].status === 3 ? '실패' : logs[i][0].type === 0 ? '대기' : '맡김' }]
          ${accounts[logs[i][0].account].username} - ${wholesales[logs[i][0].wholesale].name} ${wholesales[logs[i][0].wholesale].location.floor}층 ${
          wholesales[logs[i][0].wholesale].location.row
        }열 ${wholesales[logs[i][0].wholesale].location.place}호 (${$moment(logs[i][0].processAt).format('LLLL')})`
      "
        >
          <table class="list-type-2">
            <thead>
              <tr>
                <td v-if="!isPC">사입 내역</td>
                <td v-if="isPC">주문내역</td>
                <td v-if="isPC">메세지</td>
                <td v-if="isPC">금액</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="log in logs[i]" :key="log.idx">
                <td v-if="isPC" class="order-detail">
                  {{ log.detail.name }}
                  <a-badge :count="'×' + log.detail.amount" />
                </td>
                <td v-if="isPC">{{ log.reason || '해당 없음' }}</td>
                <td v-if="isPC">{{ parseInt(log.detail.price || '0').toLocaleString() }}원</td>
                <td v-else style="text-align: left; padding: 1em;">
                  <dl>
                    <dt>주문 내역:</dt>
                    <dd>
                      {{ log.detail.name }}
                      <a-badge :count="'×' + log.detail.amount" />
                    </dd>
                    <dt>메세지:</dt>
                    <dd>{{ log.reason || '해당 없음' }}</dd>
                    <dt>금액:</dt>
                    <dd>{{ parseInt(log.detail.price || '0').toLocaleString() }}원</dd>
                  </dl>
                </td>
              </tr>
            </tbody>
          </table>
        </a-collapse-panel>
      </a-collapse>
    </a-card>
  </TheUncle>
</template>
<script>
import TheUncle from "@/components/Uncle/TheUncle";
import Axios from "axios";
import config from "../../../config";
import AxiosMiddleware from "../../../libs/AxiosMiddleware";
import OPCODE from "../../../libs/OPCODE";

export default {
  name: "UncleUnprocessed",
  components: { TheUncle },
  mounted() {
    this.refreshLogs();
  },
  data() {
    return {
      logs: {},
      wholesales: {},
      selected: {
        filter: []
      },
      filter: {
        success: "상태: 성공",
        failed: "상태: 실패",
        saib: "타입: 사입",
        exchange: "타입: 교환/반납"
      },
      latestComplete: new Date(),
      searchs: [],
      autoComplete: [],
      search: ""
    };
  },
  methods: {
    async refreshLogs() {
      const match = this.search.match(/^.*\((.*)\)$/i);
      if (match === null || match.length < 2) this.search = "";
      else this.selected.account = match[1];

      const { data } = await Axios.post(
        `${config.hostname}/v1/uncle/saib/logs`,
        this.selected,
        { withCredentials: true }
      );

      if (AxiosMiddleware(data.opcode)) {
        switch (data.opcode) {
          case OPCODE.SUCCESS:
            this.logs = data.logs;
            this.wholesales = data.wholesales;
            this.accounts = data.accounts;
            break;
        }
      }
    },
    onDateUpdate(dates) {
      this.selected.startTime = dates[0];
      this.selected.endTime = dates[1];
    },
    onSearchChange(e) {
      if (e.key !== "Enter") return;
      this.onSearch();
    },
    async onSearch() {
      if (this.search === "") return;
      const currentTime = new Date();
      if (currentTime - this.latestComplete <= 300) return;
      this.latestComplete = currentTime;

      this.$nextTick(async () => {
        const {
          data
        } = await Axios.get(
          `${config.hostname}/v1/uncle/saib/logs?q=${this.search}`,
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.autoComplete = data.account.map(
                i => `${i.username}(${i.idx})`
              );
              break;
          }
        }
      });
    }
  }
};
</script>
<style scoped>
.ant-card-body {
  padding: 0px;
}

.ant-collapse-content > .ant-collapse-content-box {
  padding: 2px;
}
</style>